export class RiderLocation
{
    email:string="";
    latitude:string=""
    longitude:string="";
}